import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[dhlNumericField]'
})
export class NumericFieldDirective {
  @Input() decimal? = false;
  @Input() decimalSeparator?: string = '.';

  inputElement: HTMLInputElement;

  private decimalCounter = 0;
  private readonly navigationKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'Clear', 'Copy', 'Paste'];
  private readonly allowedKeys = ['a', 'c', 'v', 'x', 'a', 'c', 'v', 'x'];

  constructor(public el: ElementRef) {
    this.inputElement = el.nativeElement;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (
      this.navigationKeys.includes(e.key) || // Allow: navigation keys: backspace, delete, arrows etc.
      (this.allowedKeys.includes(e.key) && e.ctrlKey === true) ||
      (this.decimal && e.key === this.decimalSeparator && this.decimalCounter < 1) // Allow: only one decimal point
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (e.key === ' ' || isNaN(Number(e.key))) {
      e.preventDefault();
    }
  }

  @HostListener('keyup', ['$event'])
  onKeyUp(_e: KeyboardEvent) {
    if (!this.decimal) {
      return;
    } else {
      this.decimalCounter = this.el.nativeElement.value.split(this.decimalSeparator).length - 1;
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    this.inputElement.focus();
    event.preventDefault();
  }
}
